import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { BrandColors } from '../../constants';
import { TemplateSettings } from '../../store/interfaces';

export const AccessibilityDropdownStyles = makeStyles((theme: Theme) =>
  createStyles({
    accessibilityOption: {
      fontSize: '11px !important',
      backgroundColor: 'red',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      height: '40px',
      borderRadius: '5px',
      border: `1px solid ${BrandColors.grey13}`,
      marginRight: '0px',
      paddingLeft: '10px',
      paddingRight: '10px',
    },
    accessibilityList: (props: TemplateSettings) => ({
      padding: '0px',
      margin: '10px 0px',
      border: 'none',
      boxShadow: 'none',
      [theme.breakpoints.up('lg')]: {
        borderBottom: `${props.utilityBar.textColor} 1px solid`,
      },
      backgroundColor: props.utilityBar.backgroundColor,
    }),
    listItem: {
      padding: '0px',
      [theme.breakpoints.up('md')]: {
        paddingBottom: '10px',
      },
    },
    desktopMenuSettings: (props: TemplateSettings) => ({
      backgroundColor: props.utilityBar.backgroundColor,
      padding: '10px',
      maxWidth: '230px',
      borderRadius: '0.3125rem',
    }),
    accessibilityMenuCaption: (props: TemplateSettings) => ({
      fontSize: '12px !important',
      color: props.utilityBar.textColor,
    }),
    accessibilityRadio: {
      width: '1rem',
      height: '1rem',
      '&:checked': {
        accentColor: theme.palette.primary.main,
      },
    },
  }),
);
